import { NavigationBox, PostListItem } from "@components";

import React, { Fragment } from "react";
import styles from "@styles/PostList.module.scss";

type Props = {
	categories: { category: string, count: number, href: string }[];
	tags: { tag: string, count: number, href: string }[];
	posts: {
		category: string[]
		date: string
		slug: string
		tags: string[]
		title: string
		description: string
	}[]
}

const PostList: React.FC<Props> = ({
	categories, tags, posts
}) => (
	<div className={ styles.container }>
		<section className={ styles.postList }>
			{posts.map(({ category, date, slug, tags, title, description }) => (
				<Fragment key={ slug }>
					<PostListItem
						key={ slug }
						createdAt={ date }
						title={ title }
						href={ slug }
						description={ description }
						category={ { href: `/category/${category[0]}`, category: category[0] } }
						tags={ tags.map(tag => ({ href: `/tag/${tag}`, tag })) }
					/>
					<hr/>
				</Fragment>
			))}
		</section>
		<section className={ styles.navigation }>
			<NavigationBox
				categories={ categories }
				tags={ tags }
			/>
		</section>
	</div>
);

export default PostList;
